import React from 'react';
import { Flex } from '@chakra-ui/react';
import Media from '@components/atoms/Media';
import Title from '@components/atoms/Title';
import Link from '@components/atoms/Link';
import HeaderFont from '@components/atoms/HeaderFont';
import { dataLayerClick } from '@helpers/dataLayerPush';

const HeroPageLink = ({
  url = ``,
  headline = ``,
  linkTitle = ``,
  image = null
}) => {
  return (
    <Flex
      mt={{ base: `1.5rem`, md: `0` }}
      direction={{ base: `column`, lg: `row` }}
      position="relative"
      bg="white">
      <Flex
        width={{ base: `100%`, lg: `auto` }}
        height="100%"
        minWidth={{ base: `none`, lg: `28.875rem` }}
        top="0"
        left="0"
        position={{ base: `absolute`, lg: `static` }}
        alignItems="center"
        direction="column">
        <Title
          width={{ base: `50%`, lg: `auto` }}
          maxWidth={{ base: `none`, md: `none`, lg: `22rem` }}
          mb="1.5rem"
          pt={{ base: `0`, lg: `2rem` }}
          px={{ base: `0`, lg: `1.688rem` }}
          top="calc(50% - 20px)"
          right="auto"
          left="auto"
          position={{ base: `absolute`, lg: `static` }}
          zIndex="1"
          transform={{
            base: `translateX(50%) translateY(-50%)`,
            lg: `rotate(-5deg)`
          }}
          textTransform="uppercase"
          lineHeight="2.25rem"
          fontWeight="900"
          fontSize={{ base: `2xl`, lg: `3xl` }}
          fontStyle="italic"
          color="purple.600">
          <HeaderFont>{headline}</HeaderFont>
        </Title>
        <Link
          variant="ghost"
          py="0.5rem"
          px="1.5rem"
          textAlign="center"
          width={{ base: `100%`, lg: `auto` }}
          mb={{ base: `0`, lg: `2rem` }}
          borderWidth={{ base: `0`, lg: `2px` }}
          href={`/${url}`}
          position={{ base: `absolute`, lg: `static` }}
          bottom="0"
          zIndex="2"
          mt="auto"
          onClick={() => {
            dataLayerClick({
              event: `cta_click`,
              clickText: linkTitle,
              clickUrl: url
            });
          }}>
          <HeaderFont fontWeight="700" textTransform="uppercase" fontSize="md">
            {linkTitle}
          </HeaderFont>
        </Link>
      </Flex>
      <Flex maxHeight={{ base: `13.438rem`, md: `unset` }} overflow="hidden">
        <Media
          media={image}
          minHeight="14rem"
          ml={{ base: `-40%`, lg: `0` }}
          objectFit="cover"
        />
      </Flex>
    </Flex>
  );
};

export default HeroPageLink;
